export default __webpack_public_path__ + "static/media/Animations_Bar6.efa989df.svg";